import { all, call } from "redux-saga/effects"

import AdminInvoicesSagas from "./Containers/AdminInvoicesPage/saga"
import AdminUsersSagas from "./Containers/AdminUsersPage/saga"
import AlertsPage from "./Containers/AlertsPage/saga"
import BalanceSagas from "./Containers/Balance/saga"
import BusinessAccountsSagas from "./Containers/BusinessAccountsPage/saga"
import BusinessDetailsSagas from "./Containers/BusinessDetailsBlock/saga"
import CreditsSagas from "./Containers/CreditsPage/saga"
import DashboardSagas from "./Containers/DashboardPage/saga"
import HealthSagas from "./Containers/Health/saga"
import InvoicesSagas from "./Containers/InvoiceHistoryBlock/saga"
import MarketingSagas from "./Containers/MarketingPage/saga"
import PaymentMatchingSagas from "./Containers/PaymentMatchingPage/saga"
import PerksAdminSagas from "./Containers/PerksAdminPage/saga"
import PerksSagas from "./Containers/PerksPage/saga"
import PublicApiSagas from "./Containers/PersonalSettings/PublicAPI/saga"
import PricingSagas from "./Containers/PricingPage/saga"
import ReferralsSagas from "./Containers/Referrals/saga"
// import RequestsDescriptorsSagas from './Containers/RequestsPage/RequestsDescriptors/saga';
import RequestsAutoRefundSagas from "./Containers/RequestsPage/RequestsAutoRefund/saga"
import RequestsEnrollmentsSagas from "./Containers/RequestsPage/RequestsEnrollments/saga"
import RequestsGiftsSagas from "./Containers/RequestsPage/RequestsGifts/saga"
import RequestsIntegrationsSagas from "./Containers/RequestsPage/RequestsIntegrations/saga"
// RequestsReceipts migrated to Redux Toolkit thunks — see redux/ subfolder.
import RequestsVerifiInformSagas from "./Containers/RequestsPage/RequestsVerifiInform/saga"
import RequestsWithdrawalSagas from "./Containers/RequestsPage/RequestsWithdrawal/saga"
import RequestsSagas from "./Containers/RequestsPage/saga"
import UsersSagas from "./Containers/UsersPage/saga"

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    call(DashboardSagas),
    call(AlertsPage),
    call(BusinessAccountsSagas),
    call(AdminUsersSagas),
    call(RequestsEnrollmentsSagas),
    // call(RequestsDescriptorsSagas),
    call(RequestsAutoRefundSagas),
    call(RequestsIntegrationsSagas),
    call(RequestsGiftsSagas),
    call(RequestsWithdrawalSagas),
    call(RequestsVerifiInformSagas),
    call(AdminInvoicesSagas),
    call(PricingSagas),
    call(InvoicesSagas),
    call(UsersSagas),
    call(CreditsSagas),
    call(BalanceSagas),
    call(MarketingSagas),
    call(RequestsSagas),
    call(ReferralsSagas),
    call(BusinessDetailsSagas),
    call(PublicApiSagas),
    call(HealthSagas),
    call(PerksSagas),
    call(PerksAdminSagas),
    call(PaymentMatchingSagas)
  ])
}
